import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from '@vc-workspace/utils-typography';
import { PageTypes } from '@vc-workspace/utils-constants';
import { shopDetailsContainer, shopLogoStyles, btnStyles, shopLogoContainer, chatInfoStyles, imageContainerStyles, imageStyles } from './shop-page-header.module.style';
import { useState } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Divider from '@mui/material/Divider';
import { AmplitudeEventNames, sendAmplitudeData } from '@vc-workspace/utils-amplitude';
import { getDisplayImageObj } from '@vc-workspace/utils-helpers';
import { FullWidthImageCarousel } from '@vc-workspace/full-width-image-carousel';
import LightTooltip from '../tooltips/light-tooltip';
import { DownloadAppBottomSheet, ScanQRDownload } from '../app-banners/download-app';
import ShopLocationReviewWidget from './shop-location-review-widget';
import { TailwindColors } from '@vc-workspace/utils-colors';
/* eslint-disable-next-line */

var CHARACTER_LIMIT = 270;
export function ShopPageHeader(props) {
  var _useState = useState(false),
      showFullDescription = _useState[0],
      toggleFullDescription = _useState[1];

  var _useState2 = useState(false),
      chatModal = _useState2[0],
      setChatModal = _useState2[1];

  var description = props.shop.description;

  if (!showFullDescription && description) {
    description = props.shop.description.slice(0, CHARACTER_LIMIT);
  }

  function onChatWithSeller() {
    sendAmplitudeData(AmplitudeEventNames.CONTACT_SELLER, {
      source: PageTypes.MARKETPLACE_SHOP_PAGE,
      source_name: props.shop.name
    });

    if (props.context.isMobileView) {
      setChatModal(true);
    }
  }

  var logoDisplayImage = getDisplayImageObj(props.shop.logo[0], '2');
  return _jsxs(_Fragment, {
    children: [_jsxs("div", {
      className: !props.context.isMobileView ? 'page-cushion-container pt-1' : '',
      children: [_jsx(FullWidthImageCarousel, {
        sliderRightNavigation: true,
        whiteDots: true,
        children: props.shop.banners.map(function (bannerItem, index) {
          var displayImage = getDisplayImageObj(bannerItem.images[0], '2');
          return _jsx("div", {
            css: imageContainerStyles,
            children: _jsxs("picture", {
              children: [_jsx("source", {
                srcSet: displayImage.webP,
                type: "image/webp"
              }), _jsx("img", {
                "data-src": displayImage.url,
                className: "lazyload",
                css: imageStyles
              })]
            })
          }, index);
        })
      }), _jsxs("div", {
        className: "flex items-end page-cushion-container",
        css: shopLogoContainer,
        children: [logoDisplayImage.url ? _jsxs("picture", {
          children: [_jsx("source", {
            srcSet: logoDisplayImage.webP,
            type: "image/webp"
          }), _jsx("img", {
            src: logoDisplayImage.url,
            css: shopLogoStyles
          })]
        }) : _jsx("span", {
          css: shopLogoStyles
        }), _jsx(Typography, {
          type: props.context.isMobileView ? 'Headline_H2' : 'Heading2',
          color: "nero",
          className: "pl-2 w-4/5 md:w-1/2 truncate",
          semi_bold: true,
          children: props.shop.name
        })]
      }), _jsxs("div", {
        className: "pure-g page-cushion-container",
        children: [_jsxs("div", {
          className: props.context.isMobileView ? 'pure-u-1' : 'pure-u-12-24',
          children: [props.context.isMobileView ? _jsx(ShopLocationReviewWidget, {
            context: props.context,
            shop: props.shop
          }) : null, _jsx("div", {
            css: shopDetailsContainer,
            children: props.shop.description ? _jsxs("div", {
              children: [_jsx(Typography, {
                type: props.context.isMobileView ? "Body1" : "Headline_H3",
                color: props.context.isMobileView ? TailwindColors.grey[600] : TailwindColors.grey[900],
                className: "pt-6",
                bold: !props.context.isMobileView,
                semi_bold: props.context.isMobileView,
                children: "About Us"
              }), _jsxs(Typography, {
                type: props.context.isMobileView ? "Body1" : "Headline_H3",
                color: TailwindColors.grey[700],
                className: "pt-3 md:pr-6",
                onClick: function onClick() {
                  return toggleFullDescription(true);
                },
                children: [_jsx("div", {
                  dangerouslySetInnerHTML: {
                    __html: description.split('\n').join('<br />')
                  }
                }), !showFullDescription && props.shop.description.length > CHARACTER_LIMIT ? _jsx(Typography, {
                  type: 'Body1',
                  color: TailwindColors.grey[500],
                  onClick: function onClick() {
                    return toggleFullDescription(true);
                  },
                  semi_bold: true,
                  inline: true,
                  children: "\xA0... Read More"
                }) : null]
              })]
            }) : null
          })]
        }), _jsxs("div", {
          className: props.context.isMobileView ? "pure-u-1 pt-6" : "pure-u-12-24 pl-8",
          children: [!props.context.isMobileView ? _jsx(ShopLocationReviewWidget, {
            context: props.context,
            shop: props.shop
          }) : null, !props.context.isMobileView ? _jsxs(_Fragment, {
            children: [_jsx(LightTooltip, {
              title: _jsx("div", {
                className: "bg-white",
                children: _jsx(ScanQRDownload, {
                  title: _jsxs(_Fragment, {
                    children: ["Scan the QR code to start ", _jsx("br", {}), "chatting with seller! "]
                  })
                })
              }),
              children: _jsxs("div", {
                css: btnStyles,
                onClick: onChatWithSeller,
                children: [_jsx("img", {
                  src: "./_mp-images/chat_icon.svg",
                  alt: "chat-icon"
                }), _jsx("span", {
                  className: "align-middle",
                  children: "Chat with seller"
                })]
              })
            }), _jsxs("div", {
              className: "pt-3",
              children: [_jsx(Typography, {
                type: "Body1",
                color: "dim_grey",
                className: "align-top",
                inline: true,
                children: _jsx(HelpOutlineIcon, {
                  className: "pr-1"
                })
              }), _jsxs(Typography, {
                type: "Body1",
                color: "dim_grey",
                custom_style: chatInfoStyles,
                inline: true,
                children: ["Chat with seller for special requests & customisations.", _jsx("br", {}), "Usually replies in few hours"]
              })]
            })]
          }) : _jsxs("div", {
            className: "flex items-center gap-x-4 mt-2 rounded-full bg-gray-50",
            children: [_jsx(Divider, {}), _jsxs("div", {
              css: btnStyles,
              onClick: onChatWithSeller,
              children: [_jsx("img", {
                src: "./_mp-images/chat_icon.svg",
                alt: "chat-icon"
              }), "Chat"]
            }), _jsx("div", {
              className: "flex",
              children: _jsx(Typography, {
                type: "Caption",
                color: "dim_grey",
                custom_style: chatInfoStyles,
                inline: true,
                children: "Chat with seller for special requests & customisations. Usually replies in few hours"
              })
            })]
          })]
        })]
      })]
    }), _jsx(DownloadAppBottomSheet, {
      open: chatModal,
      onClose: function onClose() {
        return setChatModal(false);
      },
      context: props.context
    })]
  });
}
export default ShopPageHeader;